import type {
  IMarketGroupChanceHistory,
  IVolumePoint,
} from "~/feature/chart/types";

export const getChartTimeline = (
  chanceHistory: IMarketGroupChanceHistory[]
): number[] =>
  [
    ...new Set(
      chanceHistory.flatMap(({ historical }) =>
        historical.map(({ timestamp }) => Date.parse(timestamp))
      )
    ),
  ]
    .filter((timestamp) => Number.isFinite(timestamp))
    .sort((a, b) => a - b);

const getNearestIndex = (timeline: number[], timestamp: number) =>
  timeline.reduce(
    (nearest, bucket, index) =>
      Math.abs(bucket - timestamp) < Math.abs(timeline[nearest] - timestamp)
        ? index
        : nearest,
    0
  );

export const getNearestTimelineIndex = (
  timeline: number[],
  timestamp: number
): number | null =>
  timeline.length ? getNearestIndex(timeline, timestamp) : null;

export const alignVolumeToTimeline = (
  timeline: number[],
  volume: IVolumePoint[]
): (number | null)[] => {
  const values: (number | null)[] = timeline.map(() => null);
  const first = timeline.at(0);
  const last = timeline.at(-1);

  if (first === undefined || last === undefined) {
    return values;
  }

  for (const { timestamp, volume: value } of volume) {
    const bucket = Date.parse(timestamp);

    if (bucket < first || bucket > last) {
      continue;
    }

    const index = getNearestIndex(timeline, bucket);

    values[index] = (values[index] ?? 0) + value;
  }

  return values;
};

export const getPointLeftPercent = (index: number, count: number): number =>
  count <= 1 ? 50 : (index / (count - 1)) * 100;
